import { useState, useEffect } from "react";
import toast from "react-hot-toast";
import * as billingService from "../services/billingService";

export const useBilling = () => {
    const [banks, setBanks] = useState([]);
    const [digitalPayments, setDigitalPayments] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchData = async () => {
        try {
            setLoading(true);
            const [bankRes, digitalRes] = await Promise.all([
                billingService.getBanks(),
                billingService.getDigitalPayments()
            ]);
            setBanks(bankRes.data?.data?.accounts || bankRes.data?.accounts || []);
            setDigitalPayments(digitalRes.data?.data?.payments || digitalRes.data?.payments || []);
        } catch (err) {
            toast.error("Failed to load billing data");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const deleteBank = async (id) => {
        if (!window.confirm("Delete this bank account?")) return;
        try {
            await billingService.deleteBank(id);
            toast.success("Bank account deleted");
            fetchData();
        } catch (err) {
            toast.error("Delete failed");
        }
    };

    const deleteDigitalPayment = async (id) => {
        if (!window.confirm("Delete this payment method?")) return;
        try {
            await billingService.deleteDigitalPayment(id);
            toast.success("Payment method deleted");
            fetchData();
        } catch (err) {
            toast.error("Delete failed");
        }
    };

    return {
        banks,
        digitalPayments,
        loading,
        fetchData,
        deleteBank,
        deleteDigitalPayment
    };
};
